export default {
    LEGAL: 'legal',
    ILLEGAL: 'illegal'
};
